import { Button, Table } from "react-bootstrap";
import ConfirmDelete from "./ConfirmDelete.component";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { acceptUserById, deleteUserById } from "../../services/admin.service";
import Modal from "./Modal.component";
import { ReactComponent as PencilIcon } from "../Icons/pencil2.svg";
import EditRole from "./EditRole.component";

function UsersTable({ users, type }) {
  const queryClient = useQueryClient();
  const { isPending: isAccepting, mutate: acceptUser } = useMutation({
    mutationFn: acceptUserById,
    onSuccess: () => {
      queryClient.invalidateQueries(["RegisUsers"]);
      toast.success("User Accepted successfully");
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const { isPending: isDeleting, mutate: deleteUser } = useMutation({
    mutationFn: (id) => {
      return deleteUserById(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["allusers"]);
      toast.success("User Deleted successfully");
    },
    onError: (err) => {
      toast.error("Couldn't delete the user");
    },
  });

  return (
    <div className="mt-5 table-container">
      <Table striped bordered>
        <thead>
          <tr>
            <th>#</th>
            <th>User Name</th>
            <th>Email</th>
            {type === "allUsers" && <th> Role </th>}
            <th>{type === "allUsers" ? "Join date" : "Request date"}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {users?.map((item, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{item.username}</td>
              <td>{item.email}</td>
              {type === "allUsers" && (
                <td className="d-flex justify-content-between align-items-center ">
                  {item.role}

                  <Modal>
                    <Modal.Open opens="edit-role">
                      <Button size="sm" variant="light" className="p-0 fs-5">
                        <PencilIcon style={{ width: "20px", margin: "5px" }} />
                      </Button>
                    </Modal.Open>
                    <Modal.Window name="edit-role">
                      <EditRole name={item.username} role={item.role} id={item._id} />
                    </Modal.Window>
                  </Modal>
                </td>
              )}
              <td>{item.createdAt?.split("T")[0]}</td>
              <td className="d-flex justify-content-center gap-2">
                {type === "requests" && (
                  <Button variant="success" onClick={() => acceptUser(item._id)} disabled={isAccepting}>
                    Accept
                  </Button>
                )}
                <Modal>
                  <Modal.Open opens="delete-user">
                    <Button variant="danger">Delete</Button>
                  </Modal.Open>
                  <Modal.Window name="delete-user">
                    <ConfirmDelete
                      disabled={isDeleting}
                      resourceName={item.email}
                      onConfirm={() => deleteUser(item._id)}
                    />
                  </Modal.Window>
                </Modal>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default UsersTable;
